<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="alert"
           :class="`alert-${type}`">
        {{ label }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      }
    }
  }
</script>
